export default __webpack_public_path__ + "static/media/sunglasses.080f8a96.png";